<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Factureren"
      @next-step="$router.push({ name: 'scanOrderInvoice' })"
      @prev-step="$router.push({ name: 'scanOrderPickUp' })"
    ></next-prev-menu>

    <deliver
      :orderDetails="orderDetails"
      :shop="shop"
      :dates="dates"
      :returnText="true"
      @updateOrder="updateOrder"
    >
      <medium-select
        :medium="orderDetails.medium"
        @updateOrder="updateOrder"
        @goToInstructions="$router.push({ name: 'scanOrderPickUp' })"
      ></medium-select>
    </deliver>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useScanOrderStore } from '@/features/scanOrder/ScanOrder.store'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import OrderMixin from '@/mixins/OrderMixin'
import Deliver from '@/components/Deliver.vue'
import MediumSelect from '../MediumSelect.vue'

export default {
  data() {
    return {}
  },
  mixins: [OrderMixin],
  components: {
    NextPrevMenu,
    Deliver,
    MediumSelect
  },
  methods: {
    updateOrder(val) {
      this.scanOrderStore.updateOrderDetails(val[0], val[1])
    }
  },
  computed: {
    ...mapStores(useScanOrderStore),
    orderDetails() {
      return this.scanOrderStore.orderDetails
    },
    shop() {
      return this.scanOrderStore.shop
    },
    dates() {
      return this.scanOrderStore.deliveryDates
    }
  },
  created() {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.card {
  //height: 590px;
}
</style>
